if (!URL.canParse) {
  URL.canParse = function (url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };
}
